import axios from './axios'
import { parseAndroidToken, getAndroidBasicHeaders } from './android'
import { isAndroid } from '../android/bridge'

export const request = async (opts) => {
  const {
    method = 'get',
    url,
    data = {},
    params = {},
    headers = {},
    isAndroidWebview = false,
    withStatusCode = false,
    signal = null
  } = opts

  const finalHeaders = { ...headers }
  /* ---------- 1. Android WebView handling ------------------------- */
  if (isAndroidWebview || isAndroid()) {
    Object.assign(finalHeaders, getAndroidBasicHeaders())
    /* ----- token-handling (legacy → JWT migration, etc.) ------------ */
    const { kind, access, refresh } = parseAndroidToken(Android.getUserToken?.())

    if (access) {
      /* dynamic import avoids circular deps */
      const { ensureJwtFromLegacy, saveTokens, getTokens } = await import('./auth')

      if (kind === 'legacy') {
        /* one-shot exchange of Django token → JWT (handled inside) */
        await ensureJwtFromLegacy(access)
      } else if (kind === 'jwt' && refresh && !getTokens().refresh) {
        saveTokens({ access, refresh })
      }

      const stored = getTokens().access
      finalHeaders['JWT-Authorization'] = stored ? `Bearer ${stored}` : `${access}`
    }
  }

  /* ---------- 2. Browser fallbacks -------------------------------- */
  if (!finalHeaders['Accept-Language']) finalHeaders['Accept-Language'] = 'en'
  if (!finalHeaders['app-type']) finalHeaders['app-type'] = 'web'

  /* ---------- 3. Fire the request --------------------------------- */
  try {
    const response = await axios.request({
      url,
      method,
      data,
      params,
      headers: finalHeaders,
      signal
    })
    return withStatusCode ? response : response?.data
  } catch (err) {
    if (withStatusCode) throw err
    throw err?.response || err
  }
}

export const getMethod = (opts) => request({ ...opts, method: 'get' })
export const postMethod = (opts) => request({ ...opts, method: 'post' })
export const patchMethod = (opts) => request({ ...opts, method: 'patch' })
